export default class Tabs {
    constructor() {
        this.init();
    }

    init() {
        const tabsContainers = document.querySelectorAll('[data-tabs]');
        
        tabsContainers.forEach(container => {
            this.setupTabs(container);
        });
    }

    setupTabs(container) {
        const buttonsContainer = container.querySelector('[data-tab="buttons"]');
        if (!buttonsContainer) return;
        
        const buttons = buttonsContainer.querySelectorAll('[data-tab-button]');
        
        // Find sections inside the tabs container first
        let sections = Array.from(container.querySelectorAll('section'));
        
        // If no sections inside, look for sections between this container and the tabs_end div
        if (sections.length === 0) {
            sections = [];
            let siblingElement = container.nextElementSibling;
            let sectionCount = 0;
            
            // Collect section siblings that match the number of buttons
            while (siblingElement && sectionCount < buttons.length) {
                if (siblingElement.tagName === 'SECTION') {
                    sections.push(siblingElement);
                    sectionCount++;
                }
                
                // Stop if we hit an empty div (likely tabs_end)
                if (siblingElement.tagName === 'DIV' && 
                    siblingElement.innerHTML.trim() === '') {
                    break;
                }
                
                siblingElement = siblingElement.nextElementSibling;
            }
        }
        
        // Add carousel slide attribute to each section
        sections.forEach((section, index) => {
            section.setAttribute('data-carousel', 'slide');
        });
        
        // Add click handlers to buttons
        buttons.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.showTab(index, buttons, sections);
            });
        });
    }

    showTab(activeIndex, buttons, sections) {
        buttons.forEach((button, index) => {
            if (index === activeIndex) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });
    }
}